import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


const PreLoaderWidget = ({ isLoading }) => {

    if (isLoading) {
        return (
            <div className="preloader">
                <div className="status">
                    <div className="spinner-border avatar-sm text-primary m-2" role="status"/>
                </div>
            </div>
        );
    }
    return null;
};

const mapStateToProps = (state) => ({
    isLoading: state.loaderReducer.isLoading,
});


PreLoaderWidget.propsTypes = {
    isLoading: PropTypes.bool.isRequired,
};
export default connect(mapStateToProps)(PreLoaderWidget);